/*!
 * yt-videos-horizontal.js v1.0.0
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */

var ytPlayerConfig = { videoId: null, playerVars: { rel: 0 }, events: { 'onReady': ytVideoModal__onPlayerReady, 'onStateChange': ytVideoModal__onPlayerStateChange } }
var IFRAME_ELEMENT_ID = `yt-main--iframe`
var ytVideoModal__playerInstance = null
var ytVideoModal__videoId = null

/* Create Swiper Slider */
$('.js-yt-h-slider').each(function () {
  var sliderConfig = {
    draggable: true,
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", },
    slidesPerView: 1, spaceBetween: 2,
    breakpoints: { 768: { slidesPerView: 3, spaceBetween: 4, } },
    containerModifierClass: 'yt-slider--',
    wrapperClass: 'yt-wrapper',
  };
  var slider = new Swiper('.js-yt-h-slider.swiper', sliderConfig);
  console.debug(slider);
});

//#region YT API Handlers
/* setModalTitle */ function setModalTitle() { $("#ytVideoModalTitle")[0].innerHTML = !ytVideoModal__playerInstance.videoTitle ? $("#ytVideoModalTitle").data("loading-text") : ytVideoModal__playerInstance.videoTitle; }
/* setVideoId */ function setVideoId(linkElement) { ytVideoModal__videoId = $(linkElement).parent().attr('video-source'); console.debug("ytVideoModal__videoId:::", ytVideoModal__videoId) }
/* create instance */ function createYouTubeInstance() { ytVideoModal__playerInstance = new YT.Player(IFRAME_ELEMENT_ID, { ...ytPlayerConfig, videoId: ytVideoModal__videoId }); console.debug(`createYouTubeInstance:::`, ytVideoModal__playerInstance) }
/* load video */ function loadYouTubeVideo() { ytVideoModal__playerInstance.loadVideoById(ytVideoModal__videoId); console.debug(`loadYouTubeVideo:::`, ytVideoModal__playerInstance) }
/* stop video */ function stopYouTubeVideo() { ytVideoModal__playerInstance.stopVideo(); console.debug(`stopYouTubeVideo:::`, ytVideoModal__playerInstance) }
/* event:::onPlayerReady */ function ytVideoModal__onPlayerReady() { ytVideoModal__playerInstance.playVideo(); console.debug(`ytVideoModal__onPlayerReady:::playVideo`); }
/* event:::onPlayerStateChange */ function ytVideoModal__onPlayerStateChange() { setModalTitle(); console.debug(`ytVideoModal__onPlayerStateChange:::${ytVideoModal__playerInstance.videoTitle}`); }
//#endregion YT API Handlers

//#region Modal Event Handlers
function handleHide__ytVideoModal() { stopYouTubeVideo(); }
function handleShow__ytVideoModal() { ytVideoModal__playerInstance === null ? createYouTubeInstance() : loadYouTubeVideo() }
//#endregion Modal Event Handlers

/* YouTubeIframeAPIReady Event Listener | main.js:::dispatchEvent:::onYouTubeIframeAPIReady */
window.addEventListener("YouTubeIframeAPIReady", () => {
  $("#ytVideoModal").on("hide.bs.modal", handleHide__ytVideoModal);
  $("#ytVideoModal").on("show.bs.modal", handleShow__ytVideoModal);
  $('.js-yt-link--modal').on('click', function (e) { e.preventDefault(); setVideoId(this); $("#ytVideoModal").modal("show"); });

  console.debug(`YouTubeIframeAPIReady`, YT);
})
